import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const ClarityScript: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    if (!landingPage.integrations.clarityId) return null

    return (
        <Script id="ms-clarity" strategy="afterInteractive">
            {`(function (c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "${landingPage.integrations.clarityId}");`}
        </Script>
    )
}
